import ChatBoxView from "../components/chat/chatview";
import { IChatMessage } from "@/types/chat-types";

const ChatWindow = () => {
    const sampleMessages: IChatMessage[] = [
        {
            text: "what is the height of the eiffel tower",
            sender: "user",
        },
        {
            text: "The Eiffel Tower is approximately 330 meters (1,083 feet) tall. \n\nTERMINATE",
            sender: "bot",
            metadata: [
                {
                    content:
                        "The Eiffel Tower is approximately 330 meters (1,083 feet) tall. \n\nTERMINATE",
                    role: "user",
                },
            ],
        },
        {
            text: "what is the components of the atmosphere",
            sender: "user",
        },
        {
            text: "The atmosphere is primarily composed of nitrogen (78%) and oxygen (21%). The remaining 1% consists of argon, carbon dioxide, and trace amounts of other gases such as neon, helium, methane, krypton, and hydrogen, as well as water vapor.\n\nTERMINATE",
            sender: "bot",
            metadata: [
                {
                    content:
                        "The atmosphere is primarily composed of nitrogen (78%) and oxygen (21%). The remaining 1% consists of argon, carbon dioxide, and trace amounts of other gases such as neon, helium, methane, krypton, and hydrogen, as well as water vapor.\n\nTERMINATE",
                    role: "user",
                },
            ],
        },
        {
            text: "how does photosynthesis work",
            sender: "user",
        },
        {
            text: "Photosynthesis is a process used by plants, algae, and certain bacteria to convert light energy into chemical energy. During photosynthesis, these organisms absorb carbon dioxide and water, which, in the presence of sunlight, are transformed into glucose and oxygen. The process occurs in two main stages: the light-dependent reactions and the Calvin cycle (light-independent reactions).\n\nTERMINATE",
            sender: "bot",
            metadata: [
                {
                    content:
                        "Photosynthesis is a process used by plants, algae, and certain bacteria to convert light energy into chemical energy. During photosynthesis, these organisms absorb carbon dioxide and water, which, in the presence of sunlight, are transformed into glucose and oxygen. The process occurs in two main stages: the light-dependent reactions and the Calvin cycle (light-independent reactions).\n\nTERMINATE",
                    role: "user",
                },
            ],
        },
        {
            text: "what is quantum computing",
            sender: "user",
        },
        {
            text: "Quantum computing is a type of computing that uses quantum-mechanical phenomena, such as superposition and entanglement, to perform operations on data. Unlike classical computers that use bits (1s and 0s), quantum computers use quantum bits or qubits, which can exist in multiple states simultaneously. This allows quantum computers to solve certain problems much faster than classical computers, especially in areas like cryptography, optimization, and quantum simulations.\n\nTERMINATE",
            sender: "bot",
            metadata: [
                {
                    content:
                        "Quantum computing is a type of computing that uses quantum-mechanical phenomena, such as superposition and entanglement, to perform operations on data. Unlike classical computers that use bits (1s and 0s), quantum computers use quantum bits or qubits, which can exist in multiple states simultaneously. This allows quantum computers to solve certain problems much faster than classical computers, especially in areas like cryptography, optimization, and quantum simulations.\n\nTERMINATE",
                    role: "user",
                },
            ],
        },
        {
            text: "explain black holes",
            sender: "user",
        },
        {
            text: "A black hole is a region of spacetime where gravity is so strong that nothing, not even light, can escape from it. The boundary of this region is called the event horizon. Black holes form when massive stars collapse at the end of their life cycle. They come in different sizes, from stellar black holes (about 5-100 times the mass of our Sun) to supermassive black holes (millions or billions of times the mass of our Sun) found at the centers of galaxies.\n\nTERMINATE",
            sender: "bot",
            metadata: [
                {
                    content:
                        "A black hole is a region of spacetime where gravity is so strong that nothing, not even light, can escape from it. The boundary of this region is called the event horizon. Black holes form when massive stars collapse at the end of their life cycle. They come in different sizes, from stellar black holes (about 5-100 times the mass of our Sun) to supermassive black holes (millions or billions of times the mass of our Sun) found at the centers of galaxies.\n\nTERMINATE",
                    role: "user",
                },
            ],
        },
    ];

    return (
        <>
            <main style={{ height: "100vh", overflow: "hidden" }} className="container mx-auto p-4">
                <div className="mb-1 ml-4">
                    <h1 className="text-2xl font-bold text-gray-900 dark:text-white">
                        Chat with Genie
                    </h1>
                    <p className="text-sm font-medium text-gray-500 text-muted-foreground mt-1 mb-6">
                        Chat with your agent to get started.
                    </p>
                </div>
                <ChatBoxView initMessages={sampleMessages} />
            </main>
        </>
    );
}

export default ChatWindow;